<div class="hero_area2">
    <app-menu [config]="config"></app-menu>
    <!-- <app-carrossel [config]="config"></app-carrossel> -->
</div>
<app-pedido-finalizado-body [config]="config"></app-pedido-finalizado-body>

